import React from 'react';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { isNewUser } from '../../Config/isNewUser';
import NotFoundPage from '../../Pages/NotFoundPage';
import { isNewCompany } from '../../Config/isNewCompany';

const WaitingApproval = () => {

  const handleLogout = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('type');
    localStorage.removeItem('first');
    window.location.href="/login"
  };

  return (
    <>{isNewUser || isNewCompany ? <Container maxWidth="sm" sx={{ mb: 10, pt: 12, display: 'flex', justifyContent: 'center' }}>
      <Paper
        elevation={3}
        sx={{
          p: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          borderRadius: 4,
          backgroundColor: '#f9f9f9',
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 80, color: 'green', mb: 3 }} />
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          Kaydınız başarıyla tamamlandı!
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
          Kullanıcı onayınız verildikten sonra <strong>Biyomed Kariyeri</strong>'ni kullanmaya başlayabilirsiniz.
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
          <strong>Önemli Bilgilendirme:</strong> Kayıt onaylama süreci yoğunluktan kaynaklı 24 - 48 saate kadar sürebilir. E-posta hesabınızı düzenli olarak kontrol etmenizi, mail gelmediği takdirde bizimle tekrar iletişime geçmenizi rica ederiz. Anlayışınız için teşekkür ederiz.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant="outlined" color="error" onClick={handleLogout}>
            Çıkış Yap
          </Button>
        </Box>
      </Paper>
    </Container> : <NotFoundPage />

    }</>

  );
};

export default WaitingApproval;
